import React from 'react';
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import AccountCircle from '@material-ui/icons/AccountCircle';
import {makeStyles} from "@material-ui/core";
import clsx from "clsx";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import {drawerWidth} from "../config/consts";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {useSignOut} from "../services/auth";

export default function HeaderBar({open, setOpen, title}) {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const signOut = useSignOut();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    function handleSignOut() {
        handleCloseMenu();
        signOut()

    }

    const classes = useStyles();

    return (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
                [classes.appBarShift]: open,
            })}
        >
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    className={clsx(classes.menuButton, {
                        [classes.hide]: open,
                    })}
                >
                    <ChevronLeftIcon/>
                </IconButton>
                <Typography variant="h6" noWrap className={classes.title}>
                    {title}
                </Typography>
                <div>
                    <Button
                        variant="text"
                        color="inherit"
                        startIcon={<AccountCircle/>}
                        onClick={handleMenu}
                        className={classes.button}
                    >
                        کاربر فعال
                    </Button>

                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{vertical: "top", horizontal: "center"}}
                        keepMounted

                        open={!!anchorEl}
                        onClose={handleCloseMenu}
                    >
                        <MenuItem onClick={handleCloseMenu}>پروفایل</MenuItem>
                        <MenuItem onClick={handleSignOut}>خروج</MenuItem>
                    </Menu>
                </div>
            </Toolbar>

        </AppBar>
    )

}

const useStyles = makeStyles((theme) => ({

    title: {
        flexGrow: 1
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    }
}));
